<template>
  <ts-checkbox :value="checked" :disabled="disabled" @input="handleSelectedOptionInput">
    <div class="option-content">
      <Thumbnail
        v-if="showPicture && item.pictureUrl"
        class="picture"
        size="x-small"
        format="circle"
        :url="item.pictureUrl"
      />
      <span>{{ item.name }}</span>
    </div>
  </ts-checkbox>
</template>

<script>
import { IdState } from 'vue-virtual-scroller';

import Thumbnail from '@/components/Thumbnail.vue';

export default {
  mixins: [IdState()],
  components: {
    Thumbnail
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    showPicture: {
      type: Boolean,
      default: false
    },
    checked: {
      type: Boolean,
      default: false
    },
  },
  idState() {
    return {
      checked: false
    };
  },
  methods: {
    handleSelectedOptionInput() {
      this.idState.checked = !this.idState.checked;
      this.$emit('input', this.idState.checked);
    }
  }
};
</script>

<style lang="scss" scoped>
.option-content {
  display: flex;
  align-items: center;
}
</style>
